export default "__VITE_ASSET__g5rihgIR__"